import {createAction} from 'Shared/utilities/actionCreator';
import * as AWDLogin from 'ApplicationEntry/models/AWDLogin';

export enum AWDLoginActionType {
  CHANGE_USERNAME = 'AWDLogin/CHANGE_USERNAME',
  CHANGE_PASSWORD = 'AWDLogin/CHANGE_PASSWORD',
  LOGIN = 'AWDLogin/LOGIN',
  LOGIN_FAILURE = 'AWDLogin/LOGIN_FAILURE',
  RESET_LOGIN = 'AWDLogin/RESET_LOGIN',
}

export const showLoginFailure = (awdLogin: AWDLogin.ValidatingAWDLogin) =>
  createAction(AWDLoginActionType.LOGIN_FAILURE, {awdLogin});
export const changeUsername = (username: string) => createAction(AWDLoginActionType.CHANGE_USERNAME, {username});
export const changePassword = (password: string) => createAction(AWDLoginActionType.CHANGE_PASSWORD, {password});
export const login = (awdLogin: AWDLogin.ValidAWDLogin) => createAction(AWDLoginActionType.LOGIN, {awdLogin});
export const resetLogin = () => createAction(AWDLoginActionType.RESET_LOGIN);

type AWDLoginState = AWDLogin.AWDLogin;

type AWDLoginAction =
  | ReturnType<typeof changeUsername>
  | ReturnType<typeof changePassword>
  | ReturnType<typeof login>
  | ReturnType<typeof showLoginFailure>
  | ReturnType<typeof resetLogin>;

export default (state: AWDLoginState = AWDLogin.DefaultAWDLogin, action: AWDLoginAction): AWDLoginState => {
  switch (action.type) {
    case AWDLoginActionType.LOGIN_FAILURE: {
      const {awdLogin} = action.payload;
      return AWDLogin.UnsuccessfulAWDLogin.create(awdLogin);
    }
    case AWDLoginActionType.LOGIN: {
      const {awdLogin} = action.payload;
      return AWDLogin.ValidatingAWDLogin.create(awdLogin);
    }
    case AWDLoginActionType.CHANGE_USERNAME:
      const {username} = action.payload;
      return AWDLogin.changeUsername(username)(state);
    case AWDLoginActionType.CHANGE_PASSWORD:
      const {password} = action.payload;
      return AWDLogin.changePassword(password)(state);
    case AWDLoginActionType.RESET_LOGIN:
      return AWDLogin.DefaultAWDLogin;
    default:
      return state;
  }
};
